"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mixDomain = exports["default"] = void 0;

var getTestGatWay = function getTestGatWay(url) {
  var current = window.location.host;
  var baseUrl = '';

  if (current.includes('astable')) {
    baseUrl = '/as';
  } else if (current.includes('bstable')) {
    baseUrl = '/bs';
  } else if (current.includes('cstable')) {
    baseUrl = '/cs';
  } else if (current.includes('dstable')) {
    baseUrl = '/ds';
  } else if (current.includes('ishansong')) {
    baseUrl = '';
  } else {
    var host = window.location.host;
    baseUrl = '';
  }

  return baseUrl + url;
};

var mixDomain = function mixDomain() {
  var host = window.location.host;
  var protocol = window.location.protocol;
  var mixDomain = '';

  if (host.includes('astable')) {
    mixDomain = "".concat(protocol, "//mix-astable.bingex.com");
  } else if (host.includes('bstable')) {
    mixDomain = "".concat(protocol, "//mix-bstable.bingex.com");
  } else if (host.includes('cstable')) {
    mixDomain = "".concat(protocol, "//mix-cstable.bingex.com");
  } else if (host.includes('dstable')) {
    mixDomain = "".concat(protocol, "//mix.fat.bingex.com");
  } else if (host.includes('ishansong')) {
    mixDomain = "".concat(protocol, "//mix.ishansong.com");
  } else if (host.includes('fat.bingex')) {
    var regex = /\d+/g;
    var fatCode = host.match(regex);

    if (fatCode) {
      mixDomain = "".concat(protocol, "//mix-stable-").concat(fatCode, ".fat.bingex.com");
    } else {
      mixDomain = "".concat(protocol, "//mix.fat.bingex.com");
    }
  } else {
    mixDomain = '';
  }

  return mixDomain;
};

exports.mixDomain = mixDomain;
var _default = {
  getTestGatWay: getTestGatWay,
  mixDomain: mixDomain
};
exports["default"] = _default;